export default __webpack_public_path__ + "static/media/avatar.056abfed.webp";